import { Component, OnInit } from '@angular/core';
import { RavIcon, RavIconCircled } from '@shared/icon/icon';
import { PreferencesService } from '@shared/services/preferences.service';
import { UserSettingsKeys } from '@shared/types/settings-keys';

@Component({
  selector: 'rav-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
  RavIconCircled = RavIconCircled;
  RavIcon = RavIcon;
  documentNotificationChecked = true;
  tableAutoRefreshOnImportChecked = true;
  faxTransmissionReportsChecked = false;

  constructor(private preferences: PreferencesService) {}

  async ngOnInit() {
    this.documentNotificationChecked = await this.preferences.getSetting(
      'User',
      UserSettingsKeys.documentNotifications
    );
    this.tableAutoRefreshOnImportChecked = await this.preferences.getSetting(
      'User',
      UserSettingsKeys.tableAutoRefreshOnImport
    );
    this.faxTransmissionReportsChecked = await this.preferences.getSetting(
      'User',
      UserSettingsKeys.faxTransmissionReports
    );
  }

  /**
   * Set document notification setting.
   */
  onDocumentNotificationChange(event): void {
    this.documentNotificationChecked = event.checked;
    this.preferences.setUserPreferenceSetting(this.documentNotificationChecked, UserSettingsKeys.documentNotifications);
  }

  /**
   * Set table auto refresh on import setting.
   */
  onTableAutoRefreshOnImportChange(event): void {
    this.tableAutoRefreshOnImportChecked = event.checked;
    this.preferences.setUserPreferenceSetting(
      this.tableAutoRefreshOnImportChecked,
      UserSettingsKeys.tableAutoRefreshOnImport
    );
  }

  /**
   * Set fax transmission report setting.
   */
  onFaxTransmissionReportsChange(event): void {
    this.faxTransmissionReportsChecked = event.checked;
    this.preferences.setUserPreferenceSetting(
      this.faxTransmissionReportsChecked,
      UserSettingsKeys.faxTransmissionReports
    );
  }
}
